<template>
  <div class="zip-code-list">
    <div class="zip-code-content">
      <template v-for="(item,index) in pagingList">
        <span class="zip-code-item" :key="index">{{item}}</span>
        <template v-if="index < pagingList.length-1">,</template>
      </template>
    </div>
    <el-pagination
      v-if="list && list.length>pageSize"
      class="paging-row"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, prev, next,jumper"
      :total="totalListNum"
      background
    >
    </el-pagination>
  </div>
</template>

<script>
import {headerCellStyle} from "@/components/placeOrder/components/homeHotRecommend/homeHotRecommendWarehouseProductList";
import {isArray} from "my-tools-kit";

export default {
  name: "zipCodeList",
  props:{
    list:{
      type:Array,
      required:true,
      default:()=>[],
    },
  },
  data(){
    return {
      /* 分页参数 */
      pageSizes: [50,100,200],
      pageSize: 50,
      currentPage: 1,
    }
  },
  computed:{
    pagingList(){
      let list = this.list;
      if(!isArray(list) || !list.length) return [];
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      return list.slice(start,end);
    },
    totalListNum(){
      let list = this.list||[];
      return list.length
    },
  },
  watch:{
    list(){
      this.handleCurrentChange();
    },
  },
  methods:{
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.currentPage = val;
    },
  },
}
</script>

<style scoped lang="scss">
.zip-code-list{
  text-align: left;
  overflow: hidden;
  max-height: 300px;
  overflow-y: auto;
}
.zip-code-content{
  max-height: 250px;
  overflow: hidden auto;
}
.zip-code-item{
  &.is-active{
    color: #FF4D01;
  }
}
.paging-row{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/zipCodeRegionSearch/zipCodeList.vue